"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Paper_1 = __importDefault(require("@material-ui/core/Paper"));
var styles_1 = require("@material-ui/core/styles");
exports.default = react_1.forwardRef(function Paper(_a, ref) {
    var _b = _a.elevation, elevation = _b === void 0 ? 2 : _b, classes = _a.classes, _c = _a.withPadding, withPadding = _c === void 0 ? false : _c, rest = __rest(_a, ["elevation", "classes", "withPadding"]);
    var computedClasses = withPadding ? __assign(__assign({}, useStyles()), { classes: classes }) : classes;
    return jsx_runtime_1.jsx(Paper_1.default, __assign({ classes: computedClasses, elevation: elevation }, rest, { ref: ref }), void 0);
});
var useStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        padding: theme.spacing(3, 2),
    },
}); });
//# sourceMappingURL=Paper.js.map